/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const role = {
  /**
   *  AJAX-获取所有角色
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listRole(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_ROLE,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取角色各个模块下的权限数目
   * @param roleId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireRole(roleId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_ROLE,
      {
        roleId : roleId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加角色
   * @param name
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(name, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_ROLE,
      {
        name : name,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改角色
   * @param roleId
   * @param name
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(roleId, name, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_ROLE,
      {
        roleId: roleId,
        name : name,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除角色
   * @param roleId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  delete(roleId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_ROLE,
      {
        roleId: roleId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取各个模块的系统权限
   *  @param moduleType
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listModulePerms(moduleType, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_MODULE_PERMS,
      {
        moduleType: moduleType,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取角色下的权限
   * @param roleId
   * @param moduleType
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listRolePerms(roleId, moduleType, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_ROLE_PERMS,
      {
        roleId: roleId,
        moduleType: moduleType,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-保存权限
   * @param roleId
   * @param moduleType
   * @param permIds
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  saveRolePerms(roleId,moduleType,permIds, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SAVE_ROLE_PERMS,
      {
        roleId : roleId,
        moduleType: moduleType,
        permIds : permIds,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default role;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-role.js